export enum EmdGender {
    female = 'F',
    male = 'M',
    unknown = 'U',
    other = 'I',
}
(EmdGender as any)['female'] = 'F';
(EmdGender as any)['male'] = 'M';
(EmdGender as any)['unknown'] = 'U';
(EmdGender as any)['other'] = 'I';